import { useEffect } from 'react';
import { schemaForRoute } from '@/seo/schemaConfig';

const SCRIPT_ID = 'route-jsonld';

/**
 * Route-aware Schema.org JSON-LD injection, kept separate from the runtime
 * Open Graph / Twitter metadata manager.
 */
export default function useRouteSchema(pathname: string) {
  useEffect(() => {
    const nodes = schemaForRoute(pathname);
    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;

    if (nodes.length === 0) {
      if (existing) existing.remove();
      return;
    }

    let script = existing;
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = SCRIPT_ID;
      document.head.appendChild(script);
    }

    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': nodes,
    });
  }, [pathname]);
}